import { companyRegisterApi, userRegisterApi } from "helpers/API/AuthApi"
import { all, fork, takeEvery,put, call } from "redux-saga/effects"
import { registerCompanyError, registerCompanySuccess, registerPersonalUserError, registerPersonalUserSuccess } from "store/actions"
import { togglePageLoader } from "store/global/actions"
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { REGISTER_COMPANY, REGISTER_PERSONALUSER } from "./actionTypes"
//Account Redux states



// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend()

// Is user register successfull then direct plot user in redux.
function* registerCompany({ payload: { data, history } }) {
  localStorage.removeItem("authUser");
  try {
    yield put(togglePageLoader(true))
    const response = yield call(companyRegisterApi, data);
     console.log("REGISTER COMPANY RESPONSE ------", response);
    if (response.status === 'Success') {
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(registerCompanySuccess(response))
      yield put(togglePageLoader(false))
      // history.push("/verifyscreen");
    } else {
      yield put(registerCompanyError(response));
      yield put(togglePageLoader(false))
    }
  
  } catch (error) {
  console.log("Errrorr ", error);
   yield put(togglePageLoader(false))
    localStorage.removeItem("authUser");
    yield put(registerCompanyError(error));
  }
}

function* registerPersonalUser({ payload: { data , history} }) {

  localStorage.removeItem("authUser");
  try {
    yield put(togglePageLoader(true))
    const response = yield call(userRegisterApi, data);
    console.log("REGISTER USER RESPONSE ------", response);
    if (response.status === 'Success') {
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(registerPersonalUserSuccess(response))
      yield put(togglePageLoader(false))
      // history.push("/verifyscreen");
    } else {
      yield put(registerPersonalUserError(response));
      yield put(togglePageLoader(false))
    }

  } catch (error) {
   yield put(togglePageLoader(false))
    localStorage.removeItem("authUser");
    yield put(registerPersonalUserError(error));
  }
}

function* accountSaga() {
  yield takeEvery(REGISTER_COMPANY, registerCompany);
  yield takeEvery(REGISTER_PERSONALUSER, registerPersonalUser);
}

export default accountSaga
